var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "  Artboard 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.3 44.3 66 56a8.3 8.3 0 1 1-7-7l11.7-9.4a3.3 3.3 0 0 1 4.7 4.7ZM95 27.8a5.6 5.6 0 0 0 1.7-3.2 5.3 5.3 0 0 0-5.9-6A5.6 5.6 0 0 0 87.5 20.3l-4.4 4.4a40.9 40.9 0 0 0-20-8.3v-4H67A5.5 5.5 0 0 0 72.5 7.6a5.3 5.3 0 0 0-5.3-5.8H48.7a5.5 5.5 0 0 0-5.5 4.8 5.3 5.3 0 0 0 5.3 5.8h4.1v4a41.2 41.2 0 0 0-19 7.6 5.3 5.3 0 0 0 6.3 8.5A30.6 30.6 0 1 1 41.7 83 5.3 5.3 0 0 0 36 91.9a40.8 40.8 0 0 0 28.2 5.9A41.3 41.3 0 0 0 99 57.6a40.7 40.7 0 0 0-8.4-25.4ZM10.7 54.7a4.2 4.2 0 1 0 0 8.5H35.1a4.2 4.2 0 1 0 0-8.4Zm34.1-10.8a4.2 4.2 0 0 0-4.2-4.2H16.1a4.2 4.2 0 1 0 0 8.5H40.6A4.2 4.2 0 0 0 44.8 43.9ZM29.7 78.3a4.2 4.2 0 1 0 0-8.4H5.2a4.2 4.2 0 1 0 0 8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.eba2c601c15aaabfad3fd37df9a8c618.svg";
export { ForwardRef as ReactComponent };